// extracted by mini-css-extract-plugin
module.exports = {"project":"project-module--project--Z7C1g","content":"project-module--content--3_Ot3"};